import React from 'react';
import { store } from '../../store'
import { payerTypes } from './actions'



const _initialState = {
    isFetching: false,
    temporaryCC: {},
    payers: {}, 
    payerProductMapping: {},
}


export function payers(state=_initialState, action) {
    switch(action.type) {

        case payerTypes.SET_CC:
            state = {...state}
            state.temporaryCC[action.payerId] = action.virtualCard
            return state

        case payerTypes.REMOVE_CC:
            state = {...state}
            delete state.temporaryCC[action.payerId]
            return state

        case payerTypes.SET_PAYER:
            state = {...state}

            if (action.virtualCard !== undefined) {
                state.payers[action.payer.OrgId + "-" + action.paymentMethod] = {
                    nationalRegistryInfo: action.payer,
                    gm: {
                        type: action.paymentMethod,
                        virtualCard: action.virtualCard,
                    }
                }
            } else {
                state.payers[action.payer.OrgId + "-" + action.paymentMethod] = {
                    nationalRegistryInfo: action.payer,
                    gm: {
                        type: action.paymentMethod,
                        depositSlipPaper: action.paperSelection
                    }
                }
            }
            
            return state
        
        case payerTypes.SET_PAYMENT_METHOD:
            state = {...state}

            let customer = state.payerProductMapping[action.customerId]

            if (customer) {
                state.payerProductMapping[action.customerId][action.productCode] = action.payer
            } else {
                state.payerProductMapping[action.customerId] = {
                    [action.productCode]: action.payer
                }
            }

            return state


        default:
            return state
    }
}